import * as React from 'react'
function SvgDataTimeline(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.813 29.168l7.187-7.2 4.9 4.9a2 2 0 002.91-.085L35.076 14.11a2 2 0 00.272-2.265l-.477-.901a1.673 1.673 0 00-2.729-.329L22.4 21.568l-4.986-4.986a1.998 1.998 0 00-2.827.001L5.413 25.77a2.004 2.004 0 00.001 2.83l.572.57a1.997 1.997 0 002.827 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDataTimeline
